/**
 * /me/eos — Session 3d PR 29.
 * Owning agent: Khidmat. Detail-card-style page (NOT a list).
 */

import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

import { ErrorPanel, Loading } from "../components/Loading";
import { session3dApi } from "../lib/session3d-api";
import {
  MeActionsRow,
  MeEmployeeRequiredGate,
  Session3dMeShell,
  useCurrentEmployeeId,
} from "./_session3dShell";

export function MyEosProjectionPage() {
  const { t } = useTranslation();
  const employeeId = useCurrentEmployeeId();

  const query = useQuery({
    queryKey: ["s3d-eos-projection", employeeId],
    queryFn: () => session3dApi.getEosProjection(employeeId),
    enabled: !!employeeId,
  });

  const data = query.data;

  return (
    <MeEmployeeRequiredGate>
      <Session3dMeShell
        title={t("me.eos-projection.title", "My EOS Projection")}
        subtitle={t("me.eos-projection.subtitle", "What-if end-of-service calculator (informational only).")}
        briefContext={{
          total: 1,
          attention: 0,
          critical: 0,
          top_kind: t("me.eos-projection.title", "My EOS Projection"),
          window_label: t("me.eos-projection.window", "default: Dec 31 scenario"),
        }}
        actionsRow={
          <MeActionsRow
            khidmatPrefill={t("me.eos-projection.ask_khidmat", "Calculate my end-of-service if I leave next year.")}
          />
        }
      >
        {query.isLoading && <Loading />}
        {query.isError && <ErrorPanel message={(query.error as Error).message} />}
        {data && (
          <div className="rounded-2xl border border-border-subtle bg-white p-4 text-sm">
            <p className="text-xs text-text-tertiary">
              {t(
                "me.eos-projection.detail_note",
                "Gratuity (Article 84/85) + leave encashment + loan deductions = final net. This is an estimate — the actual amount depends on the approved termination date and policies at that time.",
              )}
            </p>
            <pre className="mt-3 overflow-x-auto rounded bg-surface-sunken p-3 font-mono text-[10px] text-text-secondary">
{JSON.stringify(data, null, 2)}
            </pre>
          </div>
        )}
      </Session3dMeShell>
    </MeEmployeeRequiredGate>
  );
}
